<template>
  <label class="input_field font_regular font_500 text_12 mb_16" :class="{ error: error, [classNameLabel]: true }">
        {{ label }}
        <span v-if="infoList.length" class="tooltip_info">
            <fluent-icon class="help_icon" :icon="infoIcon" />
            <div class="tooltip_card">
                <p v-for="(line,index) in infoList" class="mb_0 font_12" :key="index">{{line}}</p>
            </div>
        </span>
        <div style="position:relative;">
            <CannedResponse
                v-if="showMentions && hasSlashCommand && !isEmailSelectedInbox"
                v-on-clickaway="hideMentions"
                top="37"
                :search-key="mentionSearchKey"
                @click="replaceText"
            />
        </div>
            <!-- v-model="textObj.message" -->
        <textarea
            :value="value"
            :disabled="disabled"
            class="text_14 font_500 pt_10 Pb_10 pl_12 pr_12 mt_8"
            :class="[className,error ? 'error':''].join(' ')"
            :placeholder="placeholder"
            :cols="cols"
            @input="onInput"
            @change="onChange"
            @blur="onBlur"
        />
        <span v-if="error" class="message text_12 font_500">
            {{error}}
        </span>
        <span v-else-if="hint" class="hint font_regular text_12 font_500 text_black_secondary">
            {{hint}}
        </span>
    </label>
</template>

<script>
import CannedResponse from 'components/widgets/conversation/CannedResponse.vue';
import alertMixin from 'shared/mixins/alertMixin';
import { mixin as clickaway } from 'vue-clickaway';

export default {
    components:{
        CannedResponse,
    },
    mixins: [alertMixin, clickaway],
    props: {
        label: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        value: {
            type: [String, Number],
            required: true,
        },
        // textObj:{
        //     default: ()=>{return{message:""}}
        // },
        error: {
            type: String,
            default: '',
        },
        className:{
            type: String,
            default: '',
        },
        classNameLabel:{
            type: String,
            default: '',
        },
        infoIcon:{
            type: String,
            default: 'question-circle',
        },
        infoList:{
            type: Array,
            default: ()=>[],
        },
        hint:{
            type: String,
            default: '',
        },
        selectedInbox: {
            type: Object,
            default: null,
        },
        cols:{
            type: Number,
            default: 10
        },
    },
    data() {
        return {
            mentionSearchKey: '',
            showMentions: false,
            hasSlashCommand: false,
        };
    },
    computed:{
        channel_type(){
            if (!this.selectedInbox || typeof this.selectedInbox !== 'object') {
                return "";
            }
            return this.selectedInbox?.channel_type;
        },
        isEmailSelectedInbox(){
            if (this.selectedInbox?.hasOwnProperty('email')) {
                return true;
            }
            return false;
        },
    },
    watch: {
        value(updatedMessage) {
        // 'textObj.message': function(updatedMessage) {
            try {
                this.hasSlashCommand = updatedMessage[0] === '/';
                const hasNextWord = updatedMessage.includes(' ');
                const isShortCodeActive = this.hasSlashCommand && !hasNextWord;
                if (this.hasSlashCommand && this.selectedInbox == null) {
                    this.showAlert('Please select inbox first.');
                } else if (
                    this.hasSlashCommand &&
                    this.selectedInbox != null &&
                    this.channel_type !== 'Channel::Whatsapp'
                ) {
                    this.showAlert(
                    'Please select 360 whatsapp inbox to use canned response.'
                    );
                }
                if (
                    isShortCodeActive &&
                    this.selectedInbox != null &&
                    this.channel_type === 'Channel::Whatsapp'
                ) {
                    this.mentionSearchKey = updatedMessage.substr(1, updatedMessage.length);
                    this.showMentions = true;
                } else {
                    this.mentionSearchKey = '';
                    this.showMentions = false;
                }

            } catch (error) {
                console.log(error);
            }
        },
        // selectedInbox(newInbox) {
        //      if (!newInbox || typeof newInbox !== 'object') {
        //         this.channel_type = '';
        //         return;
        //     }
        //     try {
        //         if (newInbox?.hasOwnProperty('email')) {
        //             this.isEmailSelectedInbox = true;
        //         } else {
        //             this.isEmailSelectedInbox = false;
        //             // this.selectedTemplateHtml = '';
        //             this.value = '';

        //             const inbox =  this.$store.getters['inboxes/getInbox'](
        //                 this.selectedInbox.id
        //             );
        //             console.log({inbox});
        //             this.channel_type = inbox.channel_type;
        //         }
        //     } catch (error) {
        //         const errorMessage =
        //         error?.response?.message || this.$t('CAMPAIGN.ADD.API.ERROR_MESSAGE');
        //         this.showAlert(errorMessage);
        //     }
        // },
    },
    methods: {
        onChange(event) {
            this.$emit('onChange', event.target.value);
        },
        onInput(event) {
            this.$emit('input', event.target.value);
        },
        onBlur(event) {
            this.$emit('blur', event.target.value);
        },
        replaceText(message, templateName) {
            console.log({message,templateName});
            setTimeout(() => {
                this.$emit("onCannedSelect",{message,templateName})
                // this.value = message;
                // this.templateName = templateName;
            }, 100);
        },
        hideMentions() {
            this.showMentions = false;
        },
    },
}
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.input_field{
    position: relative;
    textarea{
        // min-height: 4.2rem;
        border-color: #EEEEEE;
        &:disabled{
            background-color: #EEEEEE;
        }
        &.error{
            border-color: red;
        }
    }
}


.help_tooltip{
    position: relative;
}
.help_icon{
    position: absolute;
    top: 0;
    left: 8px;
    width: 15px;
    height: 15px;
}

.tooltip_info{
    position: relative;
    // max-width: 500px;
    &:hover {
        .tooltip_card {
            display: block;
        }
    }
    .tooltip_card{
        display: none;
        position: absolute;
        bottom: 12px;
        left: -17px;
        width: 100%;
        z-index: 1;
        min-width: 300px;
        padding: 5px 5px 5px 22px;
        background: #000;
        color: #fff;
        border-radius: 4px;
    }

}
.hint{
    display: block;
    margin-top: -1.6rem;
}

</style>
